import { createElement, type FC } from "react";

import { WarehouseImage } from "./warehouseArtifact";

export function makeArtifactImgComponents(documentId?: string): Record<string, FC<any>> {
  const ArtifactImage: FC<any> = (props) =>
    createElement(WarehouseImage, {
      src: props?.src,
      alt: props?.alt,
      documentId,
    });

  return { img: ArtifactImage };
}
